import React, { useState } from "react";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { apiErr } from "../lib/api";
import { Heart, Clapperboard, Loader2 } from "lucide-react";

export default function LoginScreen() {
  const { login } = useAuth();
  const [email, setEmail] = useState("studio@fruitlove.app");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email.trim(), password);
    } catch (e2) {
      setErr(apiErr(e2, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-bg flex items-center justify-center p-6 min-h-screen">
      <motion.div
        initial={{ opacity: 0, y: 24, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="w-full max-w-md"
      >
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="h-12 w-12 rounded-2xl candy-strawberry grid place-items-center glow-strawberry">
            <Clapperboard className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="font-display text-2xl font-bold leading-none">FruitLove</h1>
            <p className="text-xs tracking-[0.2em] uppercase text-slate-400 mt-1">Studio</p>
          </div>
        </div>

        <div className="glass rounded-3xl p-8 shadow-2xl" data-testid="login-card">
          <h2 className="font-display text-xl font-semibold mb-1">Welcome back, director</h2>
          <p className="text-sm text-slate-400 mb-6 flex items-center gap-1.5">
            <Heart className="h-3.5 w-3.5 text-[#FF3B60]" /> Craft Pixar-style fruit love stories
          </p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs text-slate-400 mb-1.5 block">Email</label>
              <input
                data-testid="login-username-input"
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-xl bg-black/30 border border-white/10 px-4 py-3 text-sm outline-none focus:border-[#FF3B60] transition-colors"
                placeholder="studio@fruitlove.app"
              />
            </div>
            <div>
              <label className="text-xs text-slate-400 mb-1.5 block">Password</label>
              <input
                data-testid="login-password-input"
                type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-xl bg-black/30 border border-white/10 px-4 py-3 text-sm outline-none focus:border-[#FF3B60] transition-colors"
                placeholder="••••••••"
              />
            </div>
            {err && <p className="text-sm text-[#FF7675]" data-testid="login-error">{err}</p>}
            <button
              data-testid="login-submit-btn" type="submit" disabled={loading}
              className="w-full candy-strawberry rounded-xl py-3 font-semibold text-white flex items-center justify-center gap-2 hover:opacity-90 transition-opacity disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
              {loading ? "Entering studio…" : "Enter Studio"}
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-slate-500 mt-6">Single-login studio · v1</p>
      </motion.div>
    </div>
  );
}
